import apiService from './api';
import type { ApiResponse } from '../types';

export interface Notification {
  id: number;
  type: string;
  title: string;
  body: string | null;
  data: Record<string, string>;
  read: boolean;
  created_at: string;
}

class NotificationsService {
  async getNotifications(): Promise<ApiResponse<Notification[]>> {
    return apiService.get('/notifications');
  }

  async getUnreadCount(): Promise<ApiResponse<{ count: number }>> {
    return apiService.get('/notifications/unread-count');
  }

  async markRead(id: number): Promise<ApiResponse<{ id: number; read: boolean }>> {
    return apiService.patch(`/notifications/${id}/read`, {});
  }

  async markAllRead(): Promise<ApiResponse<void>> {
    return apiService.patch('/notifications/read-all', {});
  }

  async registerPushToken(token: string, platform: 'ios' | 'android' | 'web'): Promise<ApiResponse<void>> {
    return apiService.post('/notifications/register-push-token', { token, platform });
  }
}

export const notificationsService = new NotificationsService();
export default notificationsService;
